import { Mask } from '../mask.interface';
export class AddressNumberModel implements Mask {

private addressNumberMask = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

  getMaskRule(): (string | RegExp)[] | Function | boolean {
    return this.addressNumberMask;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/input/rules/implementations/addressNumber.model.ts